module.exports = __webpack_public_path__ + "static/img/Process.ac505f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Process.png
// module id = uU+z
// module chunks = 0